// extracted by mini-css-extract-plugin
module.exports = {"text-large":"16px","comments":"Comments-module--comments--6bc7e4","title":"Comments-module--title--0222f5"};